import {faLink} from '@fortawesome/pro-solid-svg-icons';
import {getCurrentSelection} from '../editor-toolbar/ToolbarToggle';

const linkEdit = {current: null};

const findParentLink = node => {
  if (!node?.nodeName) return null;

  if (node.nodeName === 'A') {
    return node;
  }

  return findParentLink(node.parentNode);
};

const initLinkEdit = () => {
  const current = getCurrentSelection();

  if (!current) {
    linkEdit.current = null;

    return null;
  }

  const {range} = current;

  const startContainer = range.startContainer;
  const endContainer = range.endContainer;

  const restoreSelection = () => {
    const newRange = document.createRange();

    newRange.setStart(startContainer, range.startOffset);
    newRange.setEnd(endContainer, range.endOffset);

    const newSelection = window.getSelection();

    newSelection.removeAllRanges();
    newSelection.addRange(newRange);
  };

  const linkNodeCurrent = findParentLink(range?.commonAncestorContainer);

  linkEdit.current = {
    text: linkNodeCurrent?.textContent ?? range?.toString(),
    url: linkNodeCurrent?.href,
    targetBlank: true,
    linkNodeCurrent,
    range: {
      commonAncestorContainer: range?.commonAncestorContainer,
      endContainer: range?.endContainer,
      endOffset: range?.endOffset,
      startContainer: range?.startContainer,
      startOffset: range?.startOffset,
    },
    restoreSelection,
  };

  return {
    'link.url': linkEdit.current.url,
    'link.text': linkEdit.current.text,
  };
};

const focusContentEditableParent = startContainer => {
  let container = startContainer;

  while (container != null && container?.contentEditable !== 'true') {
    container = container?.parentNode;
  }

  if (container) {
    container.focus();
    container.click();
  }
};

const createLink = (url = '', title, blank = true) => {
  if (!linkEdit.current) return;

  const {range, linkNodeCurrent, restoreSelection} = linkEdit.current;

  // if already a link, update it
  if (linkNodeCurrent) {
    const href = url || linkNodeCurrent.href || '';

    linkNodeCurrent.href = href;
    linkNodeCurrent.textContent = title ?? href;

    if (blank) {
      linkNodeCurrent.target = '_blank';
    }

    focusContentEditableParent(linkNodeCurrent);

    // set cursor to the end of the link
    const newRange = document.createRange();

    newRange.setStart(linkNodeCurrent, linkNodeCurrent.childNodes.length);
    newRange.setEnd(linkNodeCurrent, linkNodeCurrent.childNodes.length);

    const newSelection = window.getSelection();

    newSelection.removeAllRanges();
    newSelection.addRange(newRange);

    return;
  }

  if (!range) return;

  try {
    focusContentEditableParent(range.startContainer);

    // inject the link at the original selection
    restoreSelection();

    const href = url && `href="${url || ''}"`;

    document.execCommand('insertHTML', false, `<a ${href} title="Åpne lenke i ny fane" target="${blank ? '_blank' : ''}">${title || url || ''}</a>`);
  } catch (error) {
    console.error('createLink error:', error);
  }
};

export const toolbarLinkEdit = {
  icon: faLink,
  tooltip: 'Lenke',
  title: 'Lenke',
  type: 'menu',
  name: 'linkEdit',
  initValuesOnOpen: () => initLinkEdit(),
  visible: ({item, isEditing}) => !!isEditing?.(item?.id),
  onSubmit: () => {
    if (!linkEdit.current) return;

    const {url, text, targetBlank = true} = linkEdit.current || {};

    createLink(url, text, targetBlank);

    linkEdit.current = null;
  },
  fields: [
    {
      name: 'link.text',
      label: 'Tekst',
      type: 'text',
      placeholder: 'Link tekst',
      getValue: () => undefined,
      setValue: value => {
        if (!linkEdit.current) return;

        linkEdit.current.text = value;
      },
    },
    {
      name: 'link.url',
      label: 'Url',
      type: 'text',
      placeholder: 'https://www.example.com',
      autoFocus: true,
      getValue: () => undefined,
      setValue: value => {
        if (!linkEdit.current) return;

        if (value && !value.startsWith('http')) {
          value = `https://${value}`;
        }

        linkEdit.current.url = value;
      },
    },

    // {
    //   name: 'link.targetBlank',
    //   label: 'Åpne i ny fane',
    //   type: 'boolean',
    //   setValue: value => {
    //     if (!linkEdit.current) return;

    //     linkEdit.current.targetBlank = value;
    //   },
    // },
  ],
};
